export enum EmployeesReports {
  BODY_CHECK_REPORT_NAME,
  LINKS_FOR_PASSWORDS_NAME,
}
